<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer014">
<p class="part-number-with-part-title" id="_idParaDest-4"><span class="bold CharOverride-6"><a id="_idTextAnchor003"></a>ACT ONE</span></p>
<p class="part-title-with-part-number" id="_idParaDest-5"><span class="bold CharOverride-7"><a id="_idTextAnchor004"></a>Diagnosis </span></p>
<p class="extract-flush-left"><em class="italic">The play’s the thing.</em></p>
<p class="extract-right-space-after">—William Shakespeare, <em class="italic">Hamlet</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HowMidsummerNight-4-1.vue?41097b3b